export const jobChangeFrequencies = [
    {
        code: 'noMatter',
        title: 'Не имеет значения',
    },
    {
        code: 'lessThanOneYear',
        title: 'Чаще, чем 1 раз в год',
    },
    {
        code: 'lessThanTwoYears',
        title: 'Чаще, чем 2 раз в год',
    },
    {
        code: 'lessThanThreeYears',
        title: 'Чаще, чем 3 раз в год',
    },
]

export const responseStatuses = [
    {
        code: 'consider',
        title: 'Подумать',
    },
    {
        code: 'discard_by_employer',
        title: 'Не подходит',
    },
    {
        code: 'phone_interview',
        title: 'Первичный контакт',
    },
    {
        code: 'assessment',
        title: 'Тестовое задание',
    },
    {
        code: 'interview',
        title: 'Собеседование',
    },
    {
        code: 'offer',
        title: 'Предложение о работе',
    },
]